export default __webpack_public_path__ + "static/icons-2f1c0d9db5e3bff7063b746bb346220f.png";